import { Config } from '@catalogo/core-configuration';
import { listen } from '../../listen';
import experimentExposure from './experiment-exposure';
import freightCalculate from './freight-calculate';
import recommendationLoad from './recommendation';
import adsLoad from './ads';
import { eventTrack } from './event-track';
import modalOpen from './modal-open';
import { pageView, pageViewNPL } from './pageview';
import { paginationSearchPayload } from './pagination-search';
import { skuSelectedEvent } from './sku-selected';
import addToCart from './add-to-cart';

export const gaInit = (config: Config): void => {
  listen(['page:load'], events => pageView(events, config));
  listen(['page:load', 'pagination:search'], events => paginationSearchPayload(events, config));
  listen(['page:load', 'recommendation:load'], events => recommendationLoad(events, config));
  listen(['page:load', 'ads:load'], events => adsLoad(events, config));
  listen(['page:load', 'experiment:exposure'], events => experimentExposure(events, config));
  listen(['page:load', 'freight:calculate'], events => freightCalculate(events, 'freight:calculate', config));
  listen(['page:load', 'freight:error'], events => freightCalculate(events, 'freight:error', config));
  listen(['page:load', 'modal:open'], events => modalOpen(events, config));
  listen(['page:load', 'npl:load'], events => pageViewNPL(events, config));
  listen(['page:load', 'event:track'], events => eventTrack(events, config));
  listen(['page:load', 'addToCart'], events => addToCart(events, config));
  listen(['page:load', 'sku:selected'], events => skuSelectedEvent(events, config));
};
